import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import classes from './ServerSync.scss';
import { fetchNotification } from '../../store/modules/notification';
import { loginStatus } from '../../store/modules/login';
import { fetchTotalData } from '../../store/modules/totaldata';
import { fetchNote } from '../../store/modules/note';
import { fetchSettings } from '../../store/modules/settings';
import { fetchProfileSettings } from '../../store/modules/profilesettings';

const mapActionCreators = {
  fetchSettings,
  fetchProfileSettings,
  fetchNotification,
  loginStatus,
  fetchTotalData,
  fetchNote,
};

const mapStateToProps = state => ({
  notifications: state.notification.notifications,
  fetching: state.notification.fetching,
});

class ServerSync extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('de');

    // noinspection JSDeprecatedSymbols
    const now = moment().subtract(6000, 'seconds');

    this.state = {
      open: false,
      lastUpdate: now,
      updateLogin: now,
      updateTotalData: now,
      updateNote: now,
      updateNotification: now,
    };
  }

  componentDidMount() {
    this.props.loginStatus();
    this.props.fetchNotification();
    this.props.fetchSettings();
    this.props.fetchProfileSettings();
    this.fetchData = setInterval(this.fetchData, 2500);
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.notifications).length !==
      Object.keys(this.props.notifications).length
    ) {
      this.props.fetchTotalData();
    }
  }

  componentWillUnmount() {
    if (this.fetchData !== null) {
      clearInterval(this.fetchData);
    }
  }

  fetchData = () => {
    // // console.log('fetching data');

    let syncEveryXSecond = {
      notifications: 5,
      login: 5,
      totalData: 60,
      note: 60,
    };

    if (__DEV__) {
      // syncEveryXSecond = {
      //   notifications: 500,
      //   login: 500,
      //   totalData: 600,
      //   note: 600,
      // };
      //
      // syncEveryXSecond.notifications = 60;
      // syncEveryXSecond.login = 60;
    }

    const storageToken = localStorage.getItem('token');
    if (typeof storageToken !== 'undefined' && storageToken) {
      const now = moment();

      if (
        moment.duration(now.diff(this.state.updateNotification)).asSeconds() >
        syncEveryXSecond.notifications
      ) {
        this.props.fetchNotification();
        this.setState({ updateNotification: now });
        this.setState({ lastUpdate: now });
      }

      if (
        moment.duration(now.diff(this.state.updateLogin)).asSeconds() >
        syncEveryXSecond.login
      ) {
        this.props.loginStatus();
        this.setState({ updateLogin: now });
      }

      if (
        moment.duration(now.diff(this.state.updateTotalData)).asSeconds() >
        syncEveryXSecond.totalData
      ) {
        this.props.fetchTotalData();
        this.setState({ updateTotalData: now });
      }

      if (
        moment.duration(now.diff(this.state.updateNote)).asSeconds() >
        syncEveryXSecond.note
      ) {
        this.props.fetchNote();
        this.setState({ updateNote: now });
      }
    }
  };

  render() {
    if (__DEV__) {
      return (
        <div className={classes.serverSyncContainer}>
          <div className={classes.serverSync}>
            {__DEV__ ? 'Entwicklungsumgebung · ' : ''} Letzte Aktualisierung:{' '}
            {this.state.lastUpdate.format('HH:mm:ss')}
          </div>
        </div>
      );
    }
    if (__STAGE__) {
      return (
        <div className={classes.serverSyncContainer}>
          <div className={`${classes.serverSync} ${classes.serverSyncStaging}`}>
            Achtung - STAGING UMGEBUNG
          </div>
        </div>
      );
    }
    return <div />;
  }
}

ServerSync.propTypes = {
  fetchNotification: PropTypes.func.isRequired,
  fetchTotalData: PropTypes.func.isRequired,
  fetchNote: PropTypes.func.isRequired,
  fetchSettings: PropTypes.func.isRequired,
  fetchProfileSettings: PropTypes.func.isRequired,
  loginStatus: PropTypes.func.isRequired,
  notifications: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapActionCreators)(ServerSync);



// WEBPACK FOOTER //
// ./src/components/ServerSync/ServerSync.js